import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import * as moment from 'moment';

@Component({
  selector: 'app-get-date-time',
  templateUrl: './get-date-time.component.html',
  styleUrls: ['./get-date-time.component.scss']
})
export class GetDateTimeComponent implements ICellRendererAngularComp {

  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  public getDateTime(): string {
    let sendDateValue = '--';
    if (this.params.value) {
      const date = moment(this.params.value).format('MM-DD-YYYY');
      const hour = moment(this.params.value).add(24, 'hours').format('hh:mm A');
      sendDateValue = `${date} - ${hour}`;
    }
    return sendDateValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/get-date-time/get-date-time.component.ts